/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MicroConsultingClientEligibility
 */
export interface MicroConsultingClientEligibility {
    /**
     * 
     * @type {boolean}
     * @memberof MicroConsultingClientEligibility
     */
    isEligible: boolean;
}

/**
 * Check if a given object implements the MicroConsultingClientEligibility interface.
 */
export function instanceOfMicroConsultingClientEligibility(value: object): value is MicroConsultingClientEligibility {
    if (!('isEligible' in value) || value['isEligible'] === undefined) return false;
    return true;
}

export function MicroConsultingClientEligibilityFromJSON(json: any): MicroConsultingClientEligibility {
    return MicroConsultingClientEligibilityFromJSONTyped(json, false);
}

export function MicroConsultingClientEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MicroConsultingClientEligibility {
    if (json == null) {
        return json;
    }
    return {
        
        'isEligible': json['isEligible'],
    };
}

export function MicroConsultingClientEligibilityToJSON(value?: MicroConsultingClientEligibility | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isEligible': value['isEligible'],
    };
}

